import { Component } from "@angular/core";

@Component({
  selector: "icon-check-circle-tramite",
  templateUrl: "./check-circle.svg",
  standalone: true,
})
export class CheckCircleTramiteIconComponent {}

